import { Box } from '@mui/material';

interface SubtopicEditLayoutProps {
  left: JSX.Element;
  middle: JSX.Element;
  right: JSX.Element;
  buttons: JSX.Element;
}

export const SubtopicEditLayout = ({
  left,
  middle,
  right,
  buttons
}: SubtopicEditLayoutProps) => {
  return (
    <Box
      sx={{
        width: '90vw',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: {
            xs: 'center',
            md: 'space-between'
          },
          flexDirection: {
            xs: 'column',
            md: 'row'
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 0px',
            marginRight: '2rem'
          }}
        >
          {left}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 0px',
            marginRight: '2rem',
            marginTop: {
              xs: '2rem',
              md: '0'
            }
          }}
        >
          {middle}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 0px',
            marginTop: {
              xs: '2rem',
              md: '0'
            }
          }}
        >
          {right}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        {buttons}
      </Box>
    </Box>
  );
};
